import styled from 'styled-components'

export const Wrapper = styled.div<{ image: string }>`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 20px;
  height: 460px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('${({ image }) => image}');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    filter: brightness(0.6);
    z-index: 0;
  }

  @media (max-width: 1020px) {
    height: 300px;
  }
  @media (max-width: 768px) {
    overflow: hidden;
  }
  @media (max-width: 600px) {
    height: 200px;
    border-radius: 16px;
  }
`
export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 16%;
  transform: translateY(-50%);
  width: 560px;
  z-index: 2;

  & > h2 {
    color: white;
  }

  button {
    font-weight: var(--font-medium);
  }

  @media (max-width: 1300px) {
    left: 12%;
  }

  @media (max-width: 600px) {
    left: 24px;
    width: 90%;
  }
`
export const Location = styled.div`
  position: absolute;
  bottom: 30px;
  right: 5%;
  background-color: black;
  font-weight: var(--font-medium);
  color: white;
  font-size: 16px;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  z-index: 3;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`
export const GraphicWrapper = styled.div`
  position: absolute;
  width: calc(100% - 200px);
  bottom: -5%;
  left: 100px;
  z-index: 1;
  aspect-ratio: 6 / 2;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 768px) {
    width: 100%;
    left: 0;
    bottom: -11%;
    aspect-ratio: 4 / 2;

    svg {
      left: -20px;
      width: 130%;
    }
  }
`
